export default "__VITE_ASSET__zIM6dZSg__"